// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_7Kv","cls2":"YourPaperCard-cls2_sXM YourPaperCard-cls1_7Kv"};